import { useRef } from "react";
import { useGazeData } from "../../hooks/useGazeData";
import styles from "./gaze-trace.module.scss";

export function GazeTrace({ inverted = false } = {}) {
  const gazeTraceRef = useRef(null); // Store gaze trace element reference
  const className = inverted ? `${styles.gazeTrace} ${styles.inverted}` : styles.gazeTrace;

  useGazeData(({ x, y }) => {
    if (!gazeTraceRef.current) return;

    // Update gaze trace visual
    gazeTraceRef.current.style.opacity = "1";
    gazeTraceRef.current.style.transform = `translate(${x}px, ${y}px)`;
  });

  return <div ref={gazeTraceRef} className={className}></div>;
}
